import { render, staticRenderFns } from "./permissionDialog.vue?vue&type=template&id=5f6b1b91&"
import script from "./permissionDialog.vue?vue&type=script&lang=js&"
export * from "./permissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports